import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OperatorSelectComponent } from './operator-select.component';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { TranslocoModule } from '@jsverse/transloco';
import { FormErrorModule, SelectModule } from '@eg/ui';

@NgModule({
  declarations: [OperatorSelectComponent],
  imports: [CommonModule, SelectModule, TranslocoModule, FlexLayoutModule, FormErrorModule],
  exports: [OperatorSelectComponent],
})
export class OperatorModule {}
